import { Partner } from './partner-types';

export function getAddressString({
	street,
	zipcode,
	city,
}: Partner['address']) {
	if (!street && !zipcode && !city) return '';

	let addressString = street;

	if (addressString && (zipcode || city)) addressString += ', ';

	addressString += [zipcode, city].filter(Boolean).join(' ');

	return addressString;
}
